import React, { useState, useEffect } from 'react';

const Work = () => {
    const [data, setData] = useState({
        heading: "Our Products",
        subheading: "Welcome to the future of mobility with MobiCloud's cutting-edge mobile application products.",
        description: "Elevate user experiences, streamline operations, and stay ahead in the digital landscape with our innovative solutions tailored to redefine the way you engage, connect, and succeed on the go.",
        products: [
            {
                image: "/img/featured_image_1.png",
                title: "eZorder eCommerce",
                category: "E-commerce Platform",
                description: "Complete e-commerce solution with advanced inventory management and seamless payment processing."
            },
            {
                image: "/img/featured_image_2.png",
                title: "StarMploy App",
                category: "HR Management",
                description: "Comprehensive HR management platform for employee engagement and performance tracking."
            },
            {
                image: "/img/featured_image_3.png",
                title: "Seasonal Food",
                category: "Food Delivery",
                description: "Innovative food delivery platform connecting local restaurants with customers seamlessly."
            },
            {
                image: "/img/featured_image_4.png",
                title: "Artika Fashion",
                category: "Fashion Retail",
                description: "Modern fashion retail platform with AI-powered recommendations and virtual try-on features."
            }
        ]
    });

    return (
        <section id="products" className="section work-area bg-gray overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8">
                        <div className="section-heading text-center mb-5">
                            <h2 className="text-capitalize mb-4">{data.heading}</h2>
                            <h4 className="text-primary mb-3">{data.subheading}</h4>
                            <p className="text-muted fs-5">{data.description}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {data.products.map((product, idx) => (
                        <div key={idx} className="col-12 col-md-6 col-lg-3 mb-4">
                            <div className="single-work text-center bg-white rounded shadow-sm overflow-hidden">
                                <div className="work-thumb">
                                    <img src={product.image} alt={product.title} className="img-fluid" />
                                </div>
                                <div className="work-text p-4">
                                    <span className="badge bg-primary mb-2">{product.category}</span>
                                    <h5 className="mb-3">{product.title}</h5>
                                    <p className="text-muted small">{product.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row justify-content-center mt-5">
                    <div className="col-12 text-center">
                        <a href="#contact" className="btn btn-primary btn-lg">View All Products</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Work; 